<template>
  <section class="sec_home-news">
    <PartsHomeTitle title="お知らせ" />

    <div v-if="importantNews.length" class="news-list">
      <PartsNewsItem v-for="news in importantNews" :key="news.id" :news="news" />
    </div>

    <PartsBtnRound to="/news" label="すべてのお知らせを見る" />
  </section>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sec_home-news`（お知らせ）。
 *
 * 掲載対象は区分「重要」の全件（`getImportantNews`）。支給HTMLは2件だが、掲載件数はコードを正とする。
 * 母集団は `src/plugins/202-fetch-news.ts:7` の `fetchNews()` が取得する最新30件なので、
 * 31件目以降の「重要」は表示されない。
 * 件数は可変で、0件のときは `v-if` によりリストが描画されず、見出しとボタンだけになる。
 * 記事の日付・区分・タイトルは API 由来なのでハードコードしない（決定#5・§3.7）。
 */
import type { NewsType } from '@/types/domains/index';
import { TopPresenter } from '@/presenters/TopPresenter';

const presenter = new TopPresenter();
const importantNews: NewsType.News[] = presenter.getImportantNews();
</script>
